"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../../../Services");
var Types_1 = require("../../../Types");
var OfflineTemplatePanel = /** @class */ (function (_super) {
    __extends(OfflineTemplatePanel, _super);
    function OfflineTemplatePanel(props) {
        var _this = _super.call(this, props) || this;
        _this.initiateTemplateCheck = function () {
            Services_1.OfflineTemplateService.check(_this.props.applicationData.selectedLocation).then(function (hasTemplate) {
                if (!hasTemplate) {
                    Services_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteWarningEvent(_this.props.applicationData.resources.Confirm_DownloadOfflineTemplate, _this.props.applicationData.resources.Confirm_DownloadOfflineTemplate, [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Ok, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                Services_1.OfflineTemplateService.download(this.props.applicationData.selectedLocation);
                                closeModalCallback();
                                return [2 /*return*/];
                            });
                        }); })
                    ]));
                }
            });
        };
        _this.uploadTemplate = function (e) {
            e.persist();
            if (!Services_1.EventHandlerProvider.GetInstance().HasEvent()) {
                Services_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.OfflineTemplateUploadEvent(e, _this.props.applicationData.resources, _this.props.applicationData.selectedLocation));
            }
        };
        _this.downloadTemplate = function () {
            if (_this.props.applicationData.calibrationData != null) {
                Services_1.OfflineTemplateService.download(_this.props.applicationData.selectedLocation);
            }
            else {
                Services_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.NeedToCalibrateScannerWarningEvent(_this.props.applicationData.resources));
            }
        };
        return _this;
    }
    OfflineTemplatePanel.prototype.componentDidMount = function () {
        if (this.props.applicationData.calibrationData != null) {
            this.initiateTemplateCheck();
        }
    };
    OfflineTemplatePanel.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.applicationData.selectedLocation != this.props.applicationData.selectedLocation && this.props.applicationData.calibrationData != null) {
            this.initiateTemplateCheck();
        }
    };
    OfflineTemplatePanel.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { className: "mb-1" },
                    React.createElement("span", { className: "" },
                        this.props.applicationData.resources.OfflineTemplateActions,
                        ":"))),
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, null,
                    React.createElement(reactstrap_1.Button, { outline: true, color: "primary", onClick: this.downloadTemplate }, this.props.applicationData.resources.DownloadTemplate)),
                React.createElement(reactstrap_1.Col, null,
                    Services_1.saysWho().name == "IE" ? //I hate IE
                        React.createElement("label", { className: "my-0", htmlFor: "test-input", style: { cursor: "pointer" } },
                            React.createElement(reactstrap_1.Button, { outline: true, color: "primary" }, this.props.applicationData.resources.Actions_UploadFromFile))
                        :
                            React.createElement(reactstrap_1.Button, { outline: true, color: "primary" },
                                React.createElement("label", { className: "my-0", htmlFor: "test-input", style: { cursor: "pointer" } }, this.props.applicationData.resources.Actions_UploadFromFile)),
                    React.createElement("input", { style: { display: "none" }, id: "test-input", type: "file", onChange: this.uploadTemplate, accept: ".vlx" })))));
    };
    return OfflineTemplatePanel;
}(React.Component));
exports.OfflineTemplatePanel = OfflineTemplatePanel;
//# sourceMappingURL=OfflineTemplatePanel.js.map